import { render, staticRenderFns } from "./detectorReport.vue?vue&type=template&id=0c01f822&scoped=true"
import script from "./detectorReport.vue?vue&type=script&lang=js"
export * from "./detectorReport.vue?vue&type=script&lang=js"
import style0 from "./index.scss?vue&type=style&index=0&id=0c01f822&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c01f822",
  null
  
)

export default component.exports